import jwtDecode from "jwt-decode";

export function validarCNPJ(cnpj) {

  if (!cnpj || cnpj.trim() === '') return true;

  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  const numerosRepetidos = '00000000000000 11111111111111 22222222222222 33333333333333 44444444444444 55555555555555 66666666666666 77777777777777 88888888888888 99999999999999';
  if (numerosRepetidos.indexOf(cnpj) !== -1) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) return false;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) return false;

  return true;
}

export function validarCPF(cpf) {

  if (!cpf || cpf.trim() === '') return true;

  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf === '') return false;

  if (cpf.length !== 11) return false;

  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
  }

  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10))) return false;

  return true;
}

export function validarEmail(input) {
  if (Array.isArray(input)) {
    const emailsValidos = input.filter((item) => item && item.trim() !== '');

    if (emailsValidos.length === 0) return true; // array vazio ou só com strings vazias

    const regexEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    return emailsValidos.every((email) => regexEmail.test(email.trim()));
  }

  // Trata como string única
  if (!input || input.trim() === '') return true;

  const regexEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  return regexEmail.test(input.trim());
}

export function validarTelefone_(input) {
  if (Array.isArray(input)) {
    const numerosValidos = input.filter((item) => item && item.trim() !== '');

    if (numerosValidos.length === 0) return true; // array vazio ou só com strings vazias

    const regexTelefone = /^\(?(\d{2})\)?\s?(\d{4,5})\s?-?\s?(\d{4})$/;
    return numerosValidos.every((numero) => regexTelefone.test(numero.trim()));
  }

  // Trata como string única
  if (!input || input.trim() === '') return true;

  const regexTelefone = /^\(?(\d{2})\)?\s?(\d{4,5})\s?-?\s?(\d{4})$/;
  return regexTelefone.test(input.trim());
}

export function validarTelefone(input) {
  const dddsValidos = [
    '11','12','13','14','15','16','17','18','19',
    '21','22','23','24',
    '27','28',
    '31','32','33','34','35','37','38',
    '41','42','43','44','45','46','47','48','49',
    '51','52','53','54','55',
    '61','62','63','64','65','66','67','68','69',
    '71','73','74','75','77','79',
    '81','82','83','84','85','86','87','88','89',
    '91','92','93','94','95','96','97','98','99'
  ];

  // Função auxiliar para validar um número único
  const validarNumero = (numero) => {
    const regex = /^\(?(\d{2})\)?\s?(\d{4,5})\s?-?\s?(\d{4})$/;
    const match = numero.trim().match(regex);
    if (!match) return false;

    const ddd = match[1];
    return dddsValidos.includes(ddd);
  };

  // Se for array
  if (Array.isArray(input)) {
    const numerosValidos = input.filter((item) => item && item.trim() !== '');
    if (numerosValidos.length === 0) return true; // array vazio ou só com strings vazias

    return numerosValidos.every(validarNumero);
  }

  // Se for string única
  if (!input || input.trim() === '') return true;

  return validarNumero(input);
}


export function validarNome(nome) {

  if (!nome) return true;

  const regexNome = /^[a-zA-ZÀ-ú\s]+$/;
  return nome.length >= 3 && regexNome.test(nome);
}

export function validarNomeEmpresa(nome) {
  // Regex atualizado para incluir números e pontos
  const regexNome = /^[a-zA-ZÀ-ú0-9.\s]+$/;
  return nome.length >= 3 && regexNome.test(nome);
}

// 8 ou 9 digits for phone
export const maskPhone = (valueRaw) => {

  if (!valueRaw) return '';

   let value = String(valueRaw).replace(/\D/g, ""); // convert to sdtring if number

	if (value.length <= 10) {
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{2})(\d)/, "($1) $2")
		.replace(/(\d{4})(\d)/, "$1-$2")
		.replace(/(-\d{4})(\d+?)$/, "$1");
	} // end if
	else {
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{2})(\d)/, "($1) $2")
		.replace(/(\d{5})(\d)/, "$1-$2")
		.replace(/(-\d{4})(\d+?)$/, "$1");		
	} // end else
};

// Credit Card Mask
export const maskCreditcard = (value) => {
	
	var startWith = value.slice(0, 2);
	
	// If Amex
	if ((startWith == "34" || startWith == "37") ) { 
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{4})(?=\d)?(\d{6})?(\d{5})/,"$1 $2 $3")	
	} // end if
	else {
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{4})(?=\d)/, "$1 ")	  
		.replace(/(\d{4})(?=\d)/, "$1 ")
		.replace(/(\d{4})(?=\d)/, "$1 ")
		.replace(/(\d{4})(?=\d)/, "$1 ")
	} // end else
};

export const maskCPF = (value) => {

if (!value) return '';

  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const maskCNPJ = (value) => {
  return value
    .replace(/\D+/g, '') 
    .replace(/(\d{2})(\d)/, '$1.$2') 
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2') 
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') 
};

export const Callto = ({ phone, style, children }) => {
  return <a href={`tel:${phone}`} style={style}>{children}</a>;
};

export const Whatsapp = ({ phone, style, children }) => {
  return <a href={`http://api.whatsapp.com/send?phone=${phone}`} style={style} target="_blank">{children}</a>;
  
};

export const extractRFBListData = (jsonData)  => {

  let porte = '';
  let situacao = '';
  let cnae = '';

  // Percorre o array de objetos JSON
  jsonData.forEach(item => {
    // Extrai os dados de acordo com a chave
    switch (item.key) {
      case 'porte':
        // Extrai a descrição do porte
        const porteMatch = item.value.match(/descricao: (.*)/);
        if (porteMatch) {
          porte = porteMatch[1];
        }
        break;
      case 'situacao':
        // Extrai o nome e a data da situação
        const situacaoMatch = item.value.match(/nome: (.*) \| data: (.*)/);
        if (situacaoMatch) {
          situacao = `${situacaoMatch[1]} desde ${situacaoMatch[2]}`;
        }
        break;
      case 'cnae':

          // Expressão regular para extrair o valor de fiscal e descrição
          const fiscalRegex = /fiscal: (\d+)/;
          const descricaoRegex = /descricao: (.+?) \|/;

          // Executa as expressões regulares para obter os valores
          const fiscalMatch = item.value.match(fiscalRegex);
          const descricaoMatch = item.value.match(descricaoRegex);

          // Verifica se houve correspondência e extrai os valores
          const fiscal = fiscalMatch ? fiscalMatch[1] : null;
          const descricao = descricaoMatch ? descricaoMatch[1] : null;      

        if (fiscal && descricao) {
          cnae = fiscal+ ' ('+descricao+')';
        }     
        break;
      default:
        break;
    }
  });

  // Retorna os dados extraídos
  return {
    porte,
    situacao,
    cnae
  };
}

// Função para extrair os valores desejados
export const extractCnae = (value) => {
	// Expressões regulares para capturar os campos específicos
	const regexPatterns = {
	  fiscal: /fiscal:\s*([\d]+)/,
	  divisao: /divisao:\s*([\d]+)/,
	  grupo: /grupo:\s*([\d.]+)/,
	  classe: /classe:\s*([\d.-]+)/,
	  subClasse: /subClasse:\s*([\d\/-]+)/,
	  descricao: /descricao:\s*([^\|]+)/
	};
  
	// Extrair os valores usando as expressões regulares
	const result = {};
	for (const [key, regex] of Object.entries(regexPatterns)) {
	  const match = value.match(regex);
	  result[key] = match ? match[1].trim() : "Não encontrado";
	}
  
	// Retornar a estrutura desejada
	return {
		divisao: result.divisao,
		grupo: result.grupo,
		classe: result.classe,
		subClasse: result.subClasse,
		fiscal: result.fiscal,
		descricao: result.descricao
	};
  }

export const extractSimplesNacional = (value) => {
  // Expressões regulares para capturar os campos específicos
  const regexPatterns = {
    optante: /optante:\s*([^|]+)/,
    inicio: /inicio:\s*([\d\/]+)/,
    fim: /fim:\s*([\d\/]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      optante: result.optante,
      inicio: result.inicio,
      fim: result.fim
  };
}

export const  extractMatrizEndereco = (value) => {
  // Expressões regulares para capturar os campos específicos
  const regexPatterns = {
    cep: /cep:\s*([\d-]+)/,
    tipo: /tipo:\s*([^|]+)/,
    logradouro: /logradouro:\s*([^|]+)/,
    numero: /numero:\s*([^|]+)/,
    complemento: /complemento:\s*([^|]+)/,
    bairro: /bairro:\s*([^|]+)/,
    cidade: /cidade:\s*([^|]+)/,
    uf: /uf:\s*([A-Z]{2})/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      cep: result.cep,
      tipo: result.tipo,
      logradouro: result.logradouro,
      numero: result.numero,
      complemento: result.complemento,
      bairro: result.bairro,
      cidade: result.cidade,
      uf: result.uf
  };
}

export const extractNaturezaJuridica = (value) => {
  // Expressões regulares para capturar os campos específicos
  const regexPatterns = {
    codigo: /codigo:\s*(\d+)/,
    descricao: /descricao:\s*([^|]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      codigo: result.codigo,
      descricao: result.descricao
  };
} 

export const extractSituacao = (value) => {
  
  const regexPatterns = {
    id: /id:\s*(\d+)/,
    nome: /nome:\s*([^\|]+)/, // Ajuste aqui para capturar até o final da parte de nome
    data: /data:\s*([^\|]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      id: result.id,
      nome: result.nome,
      data: result.data
  };

}

export const extractPorte = (value) => {
  // Expressões regulares para capturar os campos
  const regexPatterns = {
    id: /id:\s*(\d+)/,
    descricao: /descricao:\s*([^\|]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      id: result.id,
      descricao: result.descricao
  };
}

export const formatCurrency = (value) => {

  var valorAlterado = value;
	valorAlterado = valorAlterado.replace(/\D/g, ""); // Remove todos os não dígitos
	valorAlterado = valorAlterado.replace(/(\d+)(\d{2})$/, "$1,$2"); // Adiciona a parte de centavos
	valorAlterado = valorAlterado.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // Adiciona pontos a cada três dígitos
	//valorAlterado = "€ " + valorAlterado;
	return valorAlterado;

}

export const formatNumberCurrency = (value,currency='EUR') => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(value);
}

export const formatCurrencyNoSymbol = (value) => {

  var valorAlterado = String(value);
	valorAlterado = valorAlterado.replace(/\D/g, ""); // Remove todos os não dígitos
	valorAlterado = valorAlterado.replace(/(\d+)(\d{2})$/, "$1,$2"); // Adiciona a parte de centavos
	valorAlterado = valorAlterado.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // Adiciona pontos a cada três dígitos
	valorAlterado = valorAlterado;
 
	return valorAlterado; 

}

export const formatCurrencyDecimals = (value) => {
  //if (!value) return '0,00';
  if (!value || value == '0,00') return '';

  // Garante que o valor é tratado como string e remove caracteres não numéricos
  let valorAlterado = String(value).replace(/\D/g, "");
  
  // Preenche com zeros à esquerda para garantir que haja pelo menos dois dígitos
  valorAlterado = valorAlterado.padStart(3, '0');
  
  // Extrai os centavos e a parte inteira
  const length = valorAlterado.length;
  const intPart = valorAlterado.slice(0, length - 2) || '0';
  const decimalPart = valorAlterado.slice(length - 2);
  
  // Formata a parte inteira com pontos de milhar, se necessário
  const formattedIntPart = parseInt(intPart).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  
  return `${formattedIntPart},${decimalPart}`;
};


export const formatCurrencyDecimalsWithLimit = (value,limit) => {
  //if (!value) return '0,00';
  if (!value || value == '0,00') return '';

    // Remove todos os caracteres não numéricos
    let valorAlterado = String(value).replace(/\D/g, "");
  
    // Preenche com zeros à esquerda para garantir que haja pelo menos dois dígitos
    valorAlterado = valorAlterado.padStart(3, '0');
  
    // Converte o valor alterado para número e checa o limite
    let numericValue = parseInt(valorAlterado, 10) / 100;
    if (numericValue > limit) {
      numericValue = limit;
    }
  
    // Converte o valor numérico de volta para string respeitando o formato de moeda
    valorAlterado = numericValue.toFixed(2).replace('.', ','); // Converte para string com duas casas decimais
    valorAlterado = valorAlterado.replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Adiciona pontos a cada três dígitos
  
    return valorAlterado;
};




export const formatCurrencyNoSymbolLimit = (value, limit) => {
  var valorAlterado = String(value);
  valorAlterado = valorAlterado.replace(/\D/g, ""); // Remove todos os não dígitos
  valorAlterado = valorAlterado.replace(/(\d+)(\d{2})$/, "$1,$2"); // Adiciona a parte de centavos
  valorAlterado = valorAlterado.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // Adiciona pontos a cada três dígitos

  // Converte para número e verifica se está dentro do limite
  let numericValue = parseFloat(valorAlterado.replace(/\./g, '').replace(',', '.'));
  if (numericValue > limit) {
    return limit.toFixed(2).replace('.', ',');
  }

  return valorAlterado;
}

export const formatCurrencyWithDecimal = (value) => {
  
  var texto = String(value);

  let valorNumerico = texto.replace(/[^0-9,]/g, "");

  // Converte vírgula para ponto para manipulação e depois reverte para o formato desejado
  //valorNumerico = valorNumerico.replace(",", ".");

  // Converte a string numérica para um número flutuante
  const numero = parseFloat(valorNumerico);

  // Verifica se o número é um NaN (não um número), se sim, retorna o original
  if (isNaN(numero)) return texto;

  // Formata o número com separadores de milhar e duas casas decimais
  let resultado = numero.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
  });

  // Converte novamente ponto para vírgula para o formato brasileiro
  resultado = resultado.replace(/\./g, "#").replace(/,/g, ",").replace(/#/g, ".");

  // Retorna o texto original substituindo o valor numérico pelo valor formatado
  return texto.replace(valorNumerico.replace(",", "."), resultado);
}

export const formatValueNoDecimals = (value) => {

  // Converte o valor para string para garantir que podemos usar o método replace
  let valueStr = String(value);

  // Substitui vírgulas por pontos para uniformizar o formato decimal
  valueStr = valueStr.replace(',', '.');

  // Converte a string tratada para um número flutuante
  const floatValue = parseFloat(valueStr);

  // Verifica se a conversão resultou em um número válido
  if (isNaN(floatValue)) {
    throw new Error('Invalid number format');
  }

  // Multiplica o valor por 100 e arredonda para remover as casas decimais
  const multipliedValue = Math.round(floatValue * 100);

  return String(multipliedValue);

}

export const formatPercentageNumber = (data) => {
  const number = parseFloat(data);
  if (!isNaN(number)) {
      return number.toFixed(1).replace(".", ",")+"%";
  }
  return "Valor não numérico"; // ou outra manipulação de erro de acordo com sua lógica de negócio
}

export const isJsonString = (str) => {
  if (typeof str !== 'string') {
        return false; // Não é uma string
  }
  
  try { 
    // Verifica se o valor é um objeto ou um array
    if (str.trim().startsWith('{') && str.trim().endsWith('}') || str.trim().startsWith('[') && str.trim().endsWith(']')) {
        const parsed = JSON.parse(str);
        return (typeof parsed === 'object' && parsed !== null);
      } else {
        return true;
      }
      
  } catch (error) {
      return true; // Não é um JSON válido mas ainda é uma string
  }
}

export const toJsonOrEmpty = (str) => {
  if (typeof str !== 'string' || str === null) {
    console.log('NOT A STRING');
      return {}; // Retorna um JSON vazio para entradas não-string ou null
  }

  try {
      return JSON.parse(str); // Tenta converter a string para JSON
  } catch (error) {
      return str; // Retorna a string pois não é um json
  }
}

export function createDateAsLocal(dateString) {
  const date = new Date(dateString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset);
}


export function padronizarDecimal(numeroString) {

  // Converter a string para número
  let numero = parseFloat(numeroString);
  
  // Verificar se o número é inteiro
  if (Number.isInteger(numero)) {
      // Se for inteiro, adiciona uma casa decimal ".0"
      return `${numero}.0`;
  } else {
      // Se já tiver uma casa decimal, retorna como está
      return numero.toString();
  }
}

export function handleClickScroll(target) {
		
	const element = document.getElementById(target);
	if (element) {
		// 👇 Will scroll smoothly to the top of the next section
		var elementPosition = element.offsetTop;
		element.scrollIntoView({ top: elementPosition - 70,behavior: 'smooth' });
	}
};  

export const maskCRM = (value) => {
  if (!value) return '';

  // Remove tudo que não for letra ou número
  value = value.replace(/[^\dA-Za-z]/g, '');

  let numbers = value.substring(0, 6).replace(/\D/g, ''); // só dígitos nos 6 primeiros
  let letters = value.substring(6, 8).replace(/\d/g, '').toUpperCase(); // só letras nos 2 últimos

  let result = numbers;
  
  if (numbers.length === 6) {
    result += '/';
  }

  result += letters;

  return result;
};


export const validarCRM = (value) => {
  if (!value) return false;

  const regex = /^\d{6}\/(AC|AL|AP|AM|BA|CE|DF|ES|GO|MA|MT|MS|MG|PA|PB|PR|PE|PI|RJ|RN|RS|RO|RR|SC|SP|SE|TO)$/;
  return regex.test(value);
};

export const maskCep = (value) => {
  if (!value) return '';
  return value
    .replace(/\D/g, '')           // Remove tudo que não for número
    .replace(/^(\d{5})(\d)/, '$1-$2')  // Insere traço no lugar certo
    .substring(0, 9);              // Limita para não deixar passar do formato 99999-999
};

export function maskCardNumber(raw) {

  if (!raw) return '';

  const digits = raw.replace(/\D/g, '');

  if (!digits || digits.length < 6) return '****';

  let brand = detectCardBrand(digits);

  if (brand === 'amex' && digits.length >= 15) {
    return `${digits.slice(0, 4)} ******${digits.slice(10, 11)} ${digits.slice(11, 15)}`;
  }

  if (digits.length >= 16) {
    return `${digits.slice(0, 4)} **** **** ${digits.slice(-4)}`;
  }

  return '**** **** **** ****';
}

export function detectCardBrand(number) {
  const first2 = number.slice(0, 2);
  const first4 = number.slice(0, 4);
  const first6 = number.slice(0, 6);

  if (/^4/.test(number)) return 'visa';
  if (/^5[1-5]/.test(number)) return 'mastercard';
  if (/^3[47]/.test(number)) return 'amex';
  if (/^6(?:011|5)/.test(number)) return 'discover';
  if (
    /^(4011|4312|4389|4514|4576|5041|5066|5067|5090|6277|6362|6363)/.test(first4) ||
    /^(6500|6504|6505|6509|6516|6550)/.test(first4)
  ) return 'elo';

  return 'creditcard'; // fallback
}

export function maskCardExpiry(value) {
  if (!value) return '';

  // Remove tudo que não for número
  let digits = value.replace(/\D/g, '').slice(0, 4); // até 4 números (MMYY)

  // Insere a barra automaticamente após os 2 primeiros dígitos
  if (digits.length >= 3) {
    return digits.slice(0, 2) + '/' + digits.slice(2);
  }

  return digits;
}

export function getCardBrand(numero) {
  const clean = numero.replace(/\D/g, '');

  const brands = {
    visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    mastercard: /^5[1-5][0-9]{14}$/,
    amex: /^3[47][0-9]{13}$/,
    elo: /^(4011|4312|4389|4514|4576|5041|5066|5067|5090|6277|6362|6363|650|6516|6550)/,
    hipercard: /^606282|3841/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/
  };

  for (const [bandeira, regex] of Object.entries(brands)) {
    if (regex.test(clean)) {
      return bandeira;
    }
  }

  return 'outros';
}


export function validarNumeroCartao(numero) {
  if (!numero) return true;

  const clean = numero.replace(/\D/g, '');
  const isValidLength = clean.length >= 13 && clean.length <= 19;
  const soma = clean
    .split('')
    .reverse()
    .map((d, i) => {
      let n = parseInt(d, 10);
      if (i % 2 === 1) {
        n *= 2;
        if (n > 9) n -= 9;
      }
      return n;
    })
    .reduce((acc, val) => acc + val, 0);

  return isValidLength && soma % 10 === 0;
}

export function validarNomeCartao(nome) {
  if (!nome) return true;

  const clean = nome.trim();

  // Remove múltiplos espaços
  const partes = clean.replace(/\s+/g, ' ').split(' ');

  if (partes.length < 2) return false; // Precisa ter pelo menos nome e sobrenome

  // Garante que pelo menos uma parte tenha mais de 1 letra (evita "J R")
  const partesValidas = partes.filter(p => p.length > 1);

  return partesValidas.length >= 2;
}


export function validarValidadeCartao(exp) {
  if (!exp) return true;
  
  const match = exp.match(/^(\d{2})\/?(\d{2,4})$/);
  if (!match) return false;

  let mes = parseInt(match[1], 10);
  let ano = parseInt(match[2], 10);

  if (mes < 1 || mes > 12) return false;
  if (ano < 100) {
    ano += 2000; // converte 2 dígitos para 4
  }

  const agora = new Date();
  const mesAtual = agora.getMonth() + 1;
  const anoAtual = agora.getFullYear();

  return ano > anoAtual || (ano === anoAtual && mes >= mesAtual);
}

export const validateSingleField = (validationRules, field, value) => {
  if (!validationRules?.fieldValidations) return null;

  const rule = validationRules.fieldValidations.find((v) => v.field === field);
  if (!rule) return null;

  // Ignora validação se o campo estiver vazio pois não há o que validar
  if ((value === undefined || value === null || value.trim() === '')) {
    return null;
  }

  if (typeof rule.validator === 'string' && ValidatorsMap[rule.validator]) {
    const isValid = ValidatorsMap[rule.validator](value);
    return isValid ? null : rule.errorMessage;
  }

  if (rule.minLength && value.length < rule.minLength) {
    return rule.errorMessage;
  }

  return null;
};

export function validarWebsite(url) {
  if (!url || typeof url !== 'string') return true;

  // Garante que tenha pelo menos domínio e extensão
  const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;

  return regex.test(url.trim());
}

// Bloqueia o scroll da página (útil ao abrir modais)
export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

// Libera o scroll da página (útil ao fechar modais)
export const enableBodyScroll = () => {
  document.body.style.overflow = '';
};

// Alternativa segura (ex: toggle em visibilidade de modal)
export const toggleBodyScroll = (enabled) => {
  document.body.style.overflow = enabled ? '' : 'hidden';
};

export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export function getSlugWithId(title, id) {
  if (!title || typeof title !== 'string') return `/noticias/${id}`;

  const slug = title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');

  return `/noticias/${slug}-${id}`;
}

export const tokenizarCartao = (cardData, setAlert, setAlertTitle, setAlertBody) => {
  return new Promise((resolve, reject) => {
    if (!window.Iugu) {
      setAlertTitle('Erro');
      setAlertBody('Não foi possível inicializar o sistema de pagamento. Tente novamente em instantes.');
      setAlert(true);
      return reject(new Error('Biblioteca IUGU não carregada'));
    }

    window.Iugu.createPaymentToken(cardData, (response) => {
      if (response.errors) {
        const errorMsg = Object.values(response.errors).join('; ');
        setAlertTitle('Erro no cartão');
        setAlertBody(errorMsg || 'Verifique os dados do cartão e tente novamente.');
        setAlert(true);
        return reject(new Error(errorMsg));
      }

      resolve(response.id); // ✅ Token gerado
    });
  });
};

export const resumeCompanyName = (name) => {
  if (!name || typeof name !== 'string') return '';

  // Passo 1: Limpeza básica
  let cleanName = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // remove acentos
  cleanName = cleanName.replace(/[^a-zA-Z0-9\s]/g, ''); // remove caracteres especiais
  cleanName = cleanName.replace(/\s+/g, ' ').trim(); // remove múltiplos espaços

  // Passo 2: Remove palavras jurídicas no final
  const legalTerms = [
    'LTDA', 'LIMITADA', 'EIRELI', 'ME', 'EI', 'SS',
    'UNIPESSOAL', 'SOCIEDADE', 'GRUPO', 'S/A', 'SA', 'ASSOCIACAO'
  ];

  const regexLegal = new RegExp(`(?:\\s(?:${legalTerms.join('|')})(?:\\s|$))*$`, 'i');
  cleanName = cleanName.replace(regexLegal, '').trim();

  // Passo 3: Aplicar a regra de retorno
  const parts = cleanName.split(' ');

  if (parts.length === 1) {
    // Só tem uma palavra
    return parts[0];
  }

  let result = parts[0];

  if (parts.length >= 2) {
    if (parts[1].length > 2) {
      result += ' ' + parts[1];
    } else if (parts.length >= 3) {
      // Se segunda palavra tem <= 2 chars, inclui a terceira também
      result += ' ' + parts[1] + ' ' + parts[2];
    } else {
      // Só tem 2 palavras e segunda é pequena → inclui mesmo assim
      result += ' ' + parts[1];
    }
  }

  return result;
};


/**
 * Recupera e decodifica os dados do usuário armazenados no localStorage.
 * @returns {object} Objeto decodificado do token JWT ou objeto vazio.
 */
export function getDecodedUserData() {
  try {
    const token = localStorage.getItem("@estacaodoolho/userData");
    if (!token) return {};
    const decoded = jwtDecode(token);
    return decoded || {};
  } catch (error) {
    console.error("Erro ao decodificar token do usuário:", error);
    return {};
  }
}

/**
 * Retorna os dados decodificados da token JWT armazenada
 * @param {string} storageType - 'localStorage' | 'sessionStorage'
 * @param {string} tokenKey - chave onde a token está armazenada
 * @returns {object|null} - objeto com os dados da token ou null se não encontrada ou inválida
 */
export function getDecodedTokenData(storageType = 'localStorage', tokenKey = "@estacaodoolho/userData") {
    try {
        const storage = storageType === 'sessionStorage' ? sessionStorage : localStorage;
        const token = storage.getItem(tokenKey);
        if (!token) return null;

        const decoded = jwtDecode(token);
        return decoded;
    } catch (err) {
        console.error("Erro ao decodificar a token:", err);
        return null;
    }
}

export function formatFileSize(bytes) {
  const kb = 1024;
  const mb = kb * 1024;
  const gb = mb * 1024;

  if (bytes < mb) {
    return `${Math.round(bytes / kb)} KB`;
  } else if (bytes < gb) {
    return `${(bytes / mb).toFixed(2)} MB`;
  } else {
    return `${(bytes / gb).toFixed(2)} GB`;
  }
}


/* Mapping validation methods for validateSingleFiel method */
export const ValidatorsMap = {
  validarCNPJ,
  validarCPF,
  validarEmail,
  validarTelefone,
  validarNome,
  validarNomeEmpresa,
  validarCRM,
  validarNumeroCartao,
  validarValidadeCartao,
  getCardBrand,
  validarNomeCartao,
  validarWebsite
};